import styled from 'styled-components';
import { createTypography } from 'utils';

export const TextXL = styled.p`
  ${createTypography('p', 'xl')}

  ${({ theme }) => theme.breakpoints.maxMobile} {
    ${createTypography('p', 'md')}
  }
`;

export const Text = styled.p`
  ${createTypography('p', 'md')}

  ${({ theme }) => theme.breakpoints.maxMobile} {
    ${createTypography('p', 'sm')}
  }
`;

export const TextSmall = styled.p`
  ${createTypography('p', 'sm')}
`;

export const TextLarge = styled.p`
  ${createTypography('p', 'lg')}

  ${({ theme }) => theme.breakpoints.maxMobile} {
    // This font-size is based on one component, change to md if theres a need (and update Testimonials.jsx TextLarge component)
    ${createTypography('p', 'md')}
  }
`;
